import React, { useEffect, useRef, useState } from 'react'
import { createCustormForm, getAllForms, resetFormStatus } from '../../redux/slice/form/formSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Select from "../form/select/Select";

const inputFieldTypes = [
    "text",
    "checkbox",
    "date",
    "email",
    "file",
    "number",
    "password",
    "search",
    "button",
  ];
const AddCustomForm = ({modal_id}) => {
    const close = useRef();

    const [formFields, setFormFields] = useState([
        { field_name: "", field_type: "", compulsory_field: false },
      ]);
      const [formName, setFormName] = useState("");
      const [formNameError, setFormNameError] = useState("");
      const [formFieldsError, setFormFieldsError] = useState("");
    
      const { createSuccess } = useSelector((state) => state.form);
      const { user_permissions } = useSelector((state) => state?.auth?.user);
    
      const dispatch = useDispatch();
      const navigate = useNavigate();
    
      // Function to handle changes in form name
      const handleFormNameChange = (event) => {
        setFormName(event.target.value);
      };
    
      // Function to add a new field to the form
      const addFormField = () => {
        const newField = {
          field_name: "",
          field_type: inputFieldTypes[0],
          compulsory_field: false,
        };
        setFormFields([...formFields, newField]);
      };
    
      // Function to remove a field from the form
      const removeFormField = (index) => {
        const updatedFields = [...formFields];
        updatedFields.splice(index, 1);
        setFormFields(updatedFields);
      };
    
      // Function to handle changes in field name
      const handleFieldNameChange = (index, event) => {
        const updatedFields = [...formFields];
        updatedFields[index].field_name = event.target.value;
        setFormFields(updatedFields);
      };
    
      // Function to handle changes in field type
      const handleFieldTypeChange = (index, event) => {
        const updatedFields = [...formFields];
        updatedFields[index].field_type = event.value;
        setFormFields(updatedFields);
      };
    
      // Function to handle changes in compulsory_field
      const handleCompulsoryFieldChange = (index) => {
        const updatedFields = [...formFields];
        updatedFields[index].compulsory_field =
          !updatedFields[index].compulsory_field;
        setFormFields(updatedFields);
      };
    
      // Function to validate the form before submission
      const validateForm = () => {
        let isFormValid = true;
        let isFormFieldsValid = true;
    
        // Validate form name
        if (!formName.trim()) {
          setFormNameError("Form Name is required");
          isFormValid = false;
        } else {
          setFormNameError("");
        }
    
        // Validate form fields
        formFields.forEach((field, index) => {
          if (!field.field_name.trim()) {
            isFormFieldsValid = false;
          }
        });
    
        if (!isFormFieldsValid) {
          setFormFieldsError("All Field Names are required");
          isFormValid = false;
        } else {
          setFormFieldsError("");
        }
    
        return isFormValid;
      };
    
      const onSubmit = (e) => {
        e.preventDefault();
    
        if (validateForm()) {
          dispatch(
            createCustormForm({ form_array: formFields, form_name: formName })
          );
        }
      };
    
      useEffect(() => {
        if (createSuccess) {
            dispatch(resetFormStatus());
            dispatch(getAllForms(1))
          close.current.click()
        }
      }, [createSuccess, dispatch, navigate]);
    
      // useEffect(() => {
      //   if (!user_permissions?.some(permission => permission.name === 'custom form module') || !user_permissions?.some(permission => permission.name === 'create custom form')) {
      //     navigate('/admin/dashboard')
      //   }
    
      // }, [navigate, user_permissions])
  return (
    <>
        <div
            className='modal fade'
            id={modal_id}
            data-bs-backdrop='static'
            data-bs-keyboard='false'
            tabIndex='-1'
            aria-labelledby='staticBackdropLabel1'
            aria-hidden='true'
        >
            <div className='modal-dialog modal-dialog-scrollable' role='document'>
                <div className='modal-content rounded-4 text-dark'>
                    <div className='modal-header'>
                        <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                            Add Custom Form
                        </h4>
                        <span
                            type='button'
                            className=' bg-gray hover rounded-circle border-none'
                            data-bs-dismiss='modal'
                            aria-hidden='true'
                            ref={close}
                            onClick={() => {
                                close.current.click();
                            }}
                            style={{ padding: "0px 3px" }}
                        >
                            <i
                            className='mdi mdi-close text-white'
                            style={{ fontSize: "16px" }}
                            ></i>
                        </span>
                    </div>
                    <div className='row p-2'>
                        <div className='col-md-12'>
                            <div className='card '>
                            <form onSubmit={onSubmit}>
                                <div className='row p-3'>
                                <div className='mb-0 col-md-12'>
                                    <label htmlFor='inputEmail4' className='form-label'>
                                    Form Name <span className='text-danger'>*</span>
                                    </label>
                                    <input
                                    textname='form name'
                                    name='office_name'
                                    onChange={handleFormNameChange}
                                    value={formName}
                                    type='text'
                                    className={`form-control form-control-sm mb-2`}
                                    placeholder='Form Name'
                                    />
                                    {formNameError && (
                                    <span className='text-danger'>{formNameError}</span>
                                    )}
                                </div>
                                <div className='col-md-12 row mt-3'>
                                    <div className='col-md-10'>
                                    {formFields.map((field, index) => (
                                        <div className='mb-1' key={index}>
                                        <div key={index} className=' row'>
                                            <div className='col-md-5'>
                                            <label htmlFor='inputEmail4' className='form-label'>
                                                Field Name
                                            </label>
                                            <input
                                                type='text'
                                                placeholder='Field Name'
                                                value={field.field_name}
                                                className={`form-control form-control-sm`}
                                                onChange={(e) => handleFieldNameChange(index, e)}
                                            />
                                            </div>
                                            <div className='col-md-5'>
                                            <label htmlFor='inputEmail4' className='form-label'>
                                                Field Type
                                            </label>
                                            <Select
                                                data={inputFieldTypes?.map((item) => {
                                                return {
                                                    label: item,
                                                    value: item,
                                                };
                                                })}
                                                value={field.field_type || ""}
                                                onChange={(e) => handleFieldTypeChange(index, e)}
                                            />
                                            </div>
                                            {formFields.length > 1 && (
                                            <div className='col-md-1 mt-3 '>
                                                <label
                                                htmlFor='inputEmail4'
                                                className='form-label'
                                                ></label>
                                                <span
                                                className=''
                                                onClick={() => removeFormField(index)}
                                                >
                                                <i className='mdi mdi-delete text-danger fs-4 mdi-cursor-pointer'></i>
                                                </span>
                                            </div>
                                            )}
                                        </div>
                                        <div className='d-flex items-center gap-1 mt-1'>
                                            <input
                                            className={`form-check-input`}
                                            type='checkbox'
                                            checked={field.compulsory_field}
                                            onChange={() => handleCompulsoryFieldChange(index)}
                                            style={{ height: "20px", width: "20px" }}
                                            />
                                            <label>
                                            <p>Compulsory Field</p>
                                            </label>
                                        </div>
                                        {index === formFields.length - 1 && formFieldsError && (
                                            <div className='mb-0 text-danger'>
                                            {formFieldsError}
                                            </div>
                                        )}
                                        </div>
                                    ))}
                                    </div>
                                    <div className='col-md-2'>
                                    <label htmlFor=''></label>
                                    <button
                                        type='button'
                                        className='btn btn-primary btn-sm px-4 rounded d-flex justify-content-center align-items-center gap-1'
                                        onClick={addFormField}
                                    >
                                        <i className='mdi mdi-plus'></i>
                                        <span>Add</span>
                                    </button>
                                    </div>
                                </div>
                                <div className='flex-end mt-3'>
                                    <button type='submit' className='btn btn-sm btn-primary px-4'>
                                    Create
                                    </button>
                                </div>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default AddCustomForm